module.exports = __webpack_public_path__ + "img/dongji_ps_02.a7a8e935.jpg";